import { render, staticRenderFns } from "./registerCube.vue?vue&type=template&id=6bb6010e&scoped=true&"
import script from "./registerCube.vue?vue&type=script&lang=js&"
export * from "./registerCube.vue?vue&type=script&lang=js&"
import style0 from "./registerCube.vue?vue&type=style&index=0&id=6bb6010e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb6010e",
  null
  
)

export default component.exports